import { supabase } from '../supabaseClient';

export async function askOfficeCopilot(officeId, question) {
  const { data, error } = await supabase.functions.invoke('office-copilot', {
    body: { officeId, question },
  });
  if (error) throw error;
  if (data?.error) throw new Error(data.error);
  return data.reply;
}